/**
 * CompanionAgentNode — 陪伴智能体 Canvas 节点
 * 
 * 轻量级陪伴型 Agent，特性：
 * - 自我成长（identity_rules 会被 AI 逐步进化）
 * - 无沙盒代码执行
 * - 无 Agent Loop 自循环
 * - 有 Workspace 读写能力（后端自动注入）
 * - 有定时与心跳能力（后端自动注入）
 */
import { memo, useContext } from 'react'
import { NodeProps } from 'reactflow'
import { Heart } from 'lucide-react'
import { BaseAgentNodeView, AgentNodeTheme } from './shared/BaseAgentNode'
import { ExecutionContext } from './shared/ExecutionContext'

const COMPANION_THEME: AgentNodeTheme = {
  bg: 'bg-sky-50',
  border: 'border-sky-200',
  activeBorder: 'border-sky-500',
  activeRing: 'ring-sky-400/50',
  selectedRing: 'ring-sky-500/20',
  visitedBorder: 'border-sky-300',
  visitedRing: 'ring-sky-200/50',
  handleColor: '#0ea5e9',
  iconBg: 'bg-sky-100',
  iconBgActive: 'bg-sky-500',
  labelColor: 'text-sky-900',
  subtitleColor: 'text-sky-600',
}

const CompanionAgentNode = memo(({ data, selected, id }: NodeProps) => {
  const { activeNodeId, visitedNodeIds } = useContext(ExecutionContext)
  const isActive = activeNodeId === id
  const isVisited = visitedNodeIds.has(id)

  return (
    <BaseAgentNodeView
      data={data}
      selected={selected}
      theme={COMPANION_THEME}
      icon={<Heart className={`h-4 w-4 ${isActive ? 'text-white' : 'text-sky-600'}`} />}
      subtitle={<><span>💗</span><span>自我成长</span></>}
      isActive={isActive}
      isVisited={isVisited}
    />
  )
})
CompanionAgentNode.displayName = 'CompanionAgentNode'

export { CompanionAgentNode }
